import { IDocumentData } from "common/records/Document";
import { createAction } from "common/reducers/Utils";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";
import { List } from "immutable";

// SINGLE
export const FETCH_DOCUMENT = "@documents/FETCH_DOCUMENT";
export const RECEIVE_DOCUMENT = "@documents/RECEIVE_DOCUMENT";
export const SET_DOCUMENT_LOADED = "@documents/SET_DOCUMENT_LOADED";
export const REMOVE_DOCUMENT = "@documents/REMOVE_DOCUMENT";
export const EDIT_DOCUMENT = "@documents/EDIT_DOCUMENT";
export const RESET_DOCUMENT = "@documents/RESET_DOCUMENT";
export const TOGGLE_DOCUMENT_DISPLAY = "@documents/TOGGLE_DOCUMENT_DISPLAY";
export const EDIT_DISPLAY_BOOLEAN = "@documents/EDIT_DISPLAY_BOOLEAN";
export const UPDATE_RESOURCE_DOCUMENT_DISPLAY = "@documents/UPDATE_RESOURCE_DOCUMENT_DISPLAY";
// MULTIPLE
export const FETCH_DOCUMENTS = "@documents/FETCH_DOCUMENTS";
export const RECEIVE_DOCUMENTS = "@documents/RECEIVE_DOCUMENTS";
export const SET_DOCUMENTS_LOADED = "@documents/SET_DOCUMENTS_LOADED";
export const EDIT_DOCUMENTS = "@documents/EDIT_DOCUMENTS";
export const TOGGLE_ALL_DOCUMENTS_DISPLAY = "@documents/TOGGLE_ALL_DOCUMENTS_DISPLAY";
// PRODUCT
export const PRODUCT_DOCUMENT = "@documents/PRODUCT_DOCUMENT";
// ESTIMATE LINE ITEM
export const ESTIMATE_LINE_ITEM_DOCUMENT = "@documents/ESTIMATE_LINE_ITEM_DOCUMENT";

export const DocumentActions = {
  fetchDocument: (id: number) => createAction("@documents/FETCH_DOCUMENT", { id }),
  receiveDocument: (document: Partial<IDocumentData>) => createAction("@documents/RECEIVE_DOCUMENT", { document }),
  setDocumentLoaded: (id: number) => createAction("@documents/SET_DOCUMENT_LOADED", { id }),
  editDocument: (id: number, name: string, value: any) => createAction("@documents/EDIT_DOCUMENT", { id, name, value }),
  resetDocument: (id: number) => createAction("@documents/RESET_DOCUMENT", { id }),
  toggleDocumentDisplay: (rootPath: (string | number)[], displayProp: string) =>
    createAction("@documents/TOGGLE_DOCUMENT_DISPLAY", { rootPath, displayProp }),
  updateResourceDocumentDisplay: (id: number) => createAction("@documents/UPDATE_RESOURCE_DOCUMENT_DISPLAY", { id }),

  fetchDocuments: (ids: List<number>) => createAction("@documents/FETCH_DOCUMENTS", { ids }),
  receiveDocuments: (documents: Partial<IDocumentData>[]) =>
    createAction("@documents/RECEIVE_DOCUMENTS", { documents }),
  setDocumentsLoaded: (ids: List<number>) => createAction("@documents/SET_DOCUMENTS_LOADED", { ids }),
  removeDocument: (id: number) => createAction("@documents/REMOVE_DOCUMENT", { id }),
  editDocuments: (ids: List<number>, name: string, value: any) =>
    createAction("@documents/EDIT_DOCUMENTS", { ids, name, value }),
  toggleAllDocumentsDisplay: (ids: List<number>, displayProp: string, value: boolean) =>
    createAction("@documents/TOGGLE_ALL_DOCUMENTS_DISPLAY", { ids, displayProp, value }),
  // PRODUCT
  productDocument: (productId: number, document: Partial<IDocumentData>) =>
    createAction(PRODUCT_DOCUMENT, { productId, document }),
  // ESTIMATE LINE ITEM
  estimateLineItemDocument: (estimateLineItemId: number, document: Partial<IDocumentData>) =>
    createAction(ESTIMATE_LINE_ITEM_DOCUMENT, { estimateLineItemId, document }),
  editDisplayBoolean: (event: FormUpdateEvent) => createAction(EDIT_DISPLAY_BOOLEAN, { event }),
};

export type DocumentActions = ActionsUnion<typeof DocumentActions>;
